import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, Component, OnDestroy, effect, input, output } from "@angular/core";
import { Subscription, interval } from "rxjs";

export interface CountDown {
  days: string;
  hours: string;
  minutes: string;
  seconds: string;
}

export const INIT_COUNT: CountDown = {
  hours: "00",
  minutes: "00",
  days: "00",
  seconds: "00",
};

@Component({
  selector: "codere-countdown",
  standalone: true,
  imports: [CommonModule],
  templateUrl: "./codere-countdown.component.html",
  styleUrls: ["./codere-countdown.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CodereCountdownComponent implements OnDestroy {
  countDownEvent = output<CountDown>();
  dateTime = input.required<string>();

  timersubscription: Subscription;

  countDownResult: CountDown = {
    ...INIT_COUNT,
  };

  constructor() {
    effect(() => {
      if (!this.canCountDown(this.dateTime())) {
        this.countDownEvent.emit(this.countDownResult);
      } else {
        this.initCountDown(this.dateTime());
      }
    });
  }

  canCountDown(dateTime: string) {
    return this.dateTime() && !isNaN(Date.parse(dateTime)) && new Date(dateTime).getTime() > new Date().getTime();
  }

  initCountDown(dateTo) {
    const timer = interval(1000);
    this.timersubscription = timer.subscribe({
      next: () => {
        const { days, hours, minutes, seconds, time } = this.getTime(dateTo);
        this.countDownResult = {
          days,
          hours,
          minutes,
          seconds,
        };

        this.countDownEvent.emit(this.countDownResult);
        if (time <= 1) {
          this.countDownEvent.emit(INIT_COUNT);
          this.timersubscription.unsubscribe();
        }
      },
      complete: () => {
        this.countDownEvent.emit(INIT_COUNT);
      },
    });
  }

  getTime(dateTo: string) {
    const time = (new Date(dateTo).getTime() - new Date().getTime() + 1000) / 1000;
    return {
      seconds: ("0" + Math.floor(time % 60)).slice(-2),
      minutes: ("0" + Math.floor((time / 60) % 60)).slice(-2),
      hours: ("0" + Math.floor((time / 3600) % 24)).slice(-2),
      days: ("0" + Math.floor(time / (3600 * 24))).slice(-2),
      time,
    };
  }

  ngOnDestroy(): void {
    this.timersubscription?.unsubscribe();
  }
}
